module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-section no-padding-top",
    attrs: {
      "id": "favorite-ann-list-template"
    }
  }, [_c('div', {
    staticClass: "job-list-container"
  }, [(_vm.normalizedDisplayedList.length > 0) ? _c('div', [_c('div', {
    staticClass: "job-card-grid new-type"
  }, _vm._l((_vm.normalizedDisplayedList), function(item, index) {
    return _c('JobCard', {
      key: index,
      attrs: {
        "item": item,
        "show-mark": false
      },
      on: {
        "favorite-toggle": _vm.toggleFavorite
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function() {
          return [_c('h3', {
            staticClass: "title-line",
            domProps: {
              "innerHTML": _vm._s(item.ANN_NM)
            }
          })]
        },
        proxy: true
      }, {
        key: "details",
        fn: function() {
          return [_c('p', {
            staticClass: "job-details",
            domProps: {
              "innerHTML": _vm._s(item.jobDetail)
            }
          })]
        },
        proxy: true
      }, {
        key: "recruitment-info",
        fn: function() {
          return [_c('dl', {
            staticClass: "recruitment-info"
          }, [_c('dt', [_vm._v("모집인원 : ")]), _c('dd', [_vm._v(_vm._s(item.rcptPpl) + "명")]), _vm._v(" "), _c('dt', [_vm._v("모집기간 : ")]), _c('dd', [_vm._v(_vm._s(item.APPDURNG_STED))])])]
        },
        proxy: true
      }], null, true)
    })
  }), 1), _vm._v(" "), (_vm.totalCount > _vm.viewCount) ? _c('div', {
    staticClass: "button-area btn-load-more"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.more
    }
  }, [_c('i', {
    staticClass: "ico ico-plus"
  }), _vm._v("\n          더보기\n        ")])]) : _vm._e()]) : (_vm.totalCount == 0) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n      관심 일자리로 등록한 공고가 없습니다.\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdf6050e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/member/FavoriteAnnList.vue
// module id = 1542
// module chunks = 6